// extracted by mini-css-extract-plugin
export default {"main":"response_main__v1gje","buttons":"response_buttons__np5f4"};